// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-12534c1a] .el-table [class*=el-table__row--level] .el-table__expand-icon {\n  display: none;\n}\n\n", ""]);
// Exports
module.exports = exports;
